import React from "react";
import closeIcon from "../../../assets/images/charty-party/close-icon.png";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import _ from "lodash";

const HowToPlaychpt = (props) => {
  const gameData = _.get(props, "paramsReducer.gameObj");
  const title = _.get(gameData, "screens.chpt.how_to_play_title");
  const howToPlayContent = _.get(gameData, "screens.chpt.how_to_play");
  return (
    <div>
      <div className="HowToPlaychpt">
        <div className="heading">
          {" "}
          <h1>{title}</h1>
        </div>
        <ul>
          {howToPlayContent &&
            howToPlayContent.map((item) => {
              return <li>{item}</li>;
            })}
        </ul>
        <div className="text-center">
          <button onClick={() => props.toggleHowToPlay(false)} className="h-close-btn">
            <img src={closeIcon} alt="icon" />
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  paramsReducer: state.paramsReducer,
});

export default compose(withRouter, connect(mapStateToProps, null))(HowToPlaychpt);
